const getNTV = state => state.noticeToVacate;

export default {
    getNTV,
};
